<div class="body">
    <br/>
    <div class="row">

        <div class="col-lg-12">
            <div class="table-responsive">

                <table class="table">

                    <thead style="background-color: #0f69b4;color:white;">

                        <tr>
                            <th scope="col"> Rut</th>
                            <th scope="col"> Nombre y Apellido </th>                            
                            <th scope="col"> Parentesco </th>
                            <th scope="col"> Edad </th>
                            <th scope="col"> Sexo </th>
                        </tr>

                    </thead>
                   
                    <tbody>
                        <tr [class] = "i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor = "let carga of afiliado.cargas; let i = index">
                     
                            <td>{{carga.rut}}- {{carga.dv}}</td>
                            <td>{{carga.nombres}} {{carga.apellidoPaterno}}</td>
                            <td>{{carga.parentesco}}</td>                           
                            <td>{{carga.edad}}</td>
                            <td>{{carga.sexo.nombre}}</td>
                        
                        </tr>

                    </tbody>
            
                </table>
            </div>


        </div>

        <div class="col-lg-3"> </div>

    </div>

    <!--/form-->